<mat-card class = "manage-inspection-type">
  <div class="panel_sub_header">
      <span class="panel__header__title"> {{"Search" | translate | async}}</span>
  </div>
  <div class="model-filter">
    <div class="filter-select">
      <mat-form-field  class="filter-select" style="width: 80%; margin-top:20px;">
          <mat-select  (selectionChange)="selectedModelChanged($event)" placeholder="{{ 'Model'| translate | async }}">
            <mat-option *ngFor="let model of ropeShovelModels" [value]="model">
                {{ model.Name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
  </div>
</mat-card>

<mat-card class = "manage-inspection-type">
  <div class="panel_sub_header">
      <span class="panel__header__title"> {{"Inspection Types" | translate | async}}</span>
  </div>
  <div class="model-filter">
    <div class="filter-select typelist">
        <!-- <mat-selection-list #inspectionTypesSelectionList>
          <mat-list-option *ngFor="let type of inspectionTypes" [value]='type' [(ngModel)]="type.SelectType"  (click)="selectInspectionTypesChanged(type)">
            {{type.InspectionTypeName}}
          </mat-list-option>
        </mat-selection-list> -->

        <ng-container *ngFor="let type of inspectionTypes" >
          <mat-checkbox id="check_{{type.InspectionTypeId}}"  [(ngModel)]="type.SelectType" (change)="selectInspectionTypesChanged(type)">
            <span>{{type.InspectionTypeName}}</span>
          </mat-checkbox>
        </ng-container>
      <span *ngIf="inspectionTypeLoading === true"> <mat-spinner></mat-spinner> </span>
      <span *ngIf="selectedModel === undefined && inspectionTypeLoading === false">   {{'Please select a model first' | translate | async}} </span>
      <span *ngIf="inspectionTypes?.length === 0 &&  selectedModel !== undefined && inspectionTypeLoading === false"> {{'There is no inspection types configured for ' | translate | async}} {{selectedModel?.Name}}</span>
      <button mat-raised-button style='margin-top: 20px;' color="warn" *ngIf="canAddNew && selectedModel!==undefined && inspectionTypeLoading === false" (click)="AddNewInspectionType()"> <i  class="material-icons">add</i> {{"Add New" | translate | async}} </button>
      </div>
  </div>
</mat-card>






<div class="flex flex-containers">
    <mat-card class="panel info-panels "  *ngIf="selectedInspectionType != undefined">
      <div class="panel__header" style="padding: 0px;">
        <span class="panel__header__title">
            {{"Manage"  | translate | async}} {{ selectedInspectionType?.InspectionTypeName}} {{ "Inspection" | translate | async}}

        </span>
      </div>
      <div>
        <div style='margin-top: 20px;'>
          {{'Inspection Name' | translate | async }} :
          <mat-form-field  class="filter-select"   style="margin-left: 30px;">
              <input style='margin-left: 20px' matInput [(ngModel)]="selectedInspectionType.InspectionTypeName" [formControl]="InspectionTypeNameControl" type="text" placeholder="{{'Inpsection Name' | translate | async}}">
          </mat-form-field>

          <div *ngIf="InspectionTypeNameControl.errors && (InspectionTypeNameControl.dirty || InspectionTypeNameControl.touched)" style="margin-bottom: 20px;">
              <mat-error *ngIf="InspectionTypeNameControl.errors.required">{{'An Inspection Name is required'| translate | async}}</mat-error>
            </div>
        </div>

        <div class="model-filter">
          <div class="filter-select"  style="margin-top:20px;">
              <mat-selection-list #componentSelectionList (selectionChange)= "onSelectComponent($event)">
                <mat-list-option [value]='component' [selected]='shouldHaveCheckOnThisComponent(component)' *ngFor="let component of selectedInspectionType?.CompartsViewModels"  (click)="selectComponent(component,componentSelectionList)">
                  {{component.CompartTypeName}}
                </mat-list-option>
              </mat-selection-list>
          </div>
        </div>
        <button [disabled]="saving && InspectionTypeNameControl.errors" mat-raised-button style='float: right; margin-top: 20px;' color="warn"  (click)="SaveChanges()">  {{"Save" | translate | async}} </button>
        <!-- <button mat-raised-button style='float: right; margin-top: 20px; margin-right: 20px;'   (click)="CancelAllChanges()">  {{"Cancel" | translate | async}} </button> -->
      </div>

    </mat-card>

    <mat-card class="panel  info-panels" *ngIf="selectedInspectionType !== undefined">
      <div class="panel__header"  style="padding: 0px;">
        <span class="panel__header__title">
            {{ "Measurement Points" | translate | async}}

        </span>
      </div>
      <div>
        <div class="model-filter">
            <div class="filter-select" style=" margin-top:20px;">
              <mat-selection-list #measurementPointSelectionList>
                  <mat-list-option *ngFor="let mp of selectedComponent?.MeasurementPoints" (click) = "clickedMP(mp)" [selected]="!mp.ShouldSkipDuringInspection" >
                    {{mp.MeasurementPointName}}
                  </mat-list-option>
              </mat-selection-list>
            </div>

        </div>
      </div>
    </mat-card>
  </div>
